module.exports = function () {
  this.app.$on('forgotPassword', event => {
    this.sdk.get('/me/forgotpassword', {
      email: event.email,
      // brand: this.app.brand.code,
      brand: 'dd',
      d2d: 1
    }, response => {
      if (response.success) {
        this.app.flash = { type: 'password', message: this.app.$t('events.sentPassword') }
        this.app.$emit('forgotPassResendSuccess')
      } else {
        this.app.flash = { type: 'password', message: response.message }
        this.app.$emit('forgotPassResendFailure', response)
      }
    })
  })
}



// WEBPACK FOOTER //
// ./src/events/forgot-password.js